import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'trackerStylePipe',
  standalone: true
})
export class TrackerStylePipe implements PipeTransform {
    transform(trackerStatus, chunk, i): any {
        let result = '';
        switch (trackerStatus.length) {
            case 11 : {
                       if (i === 0) {
                           result = 'no-padding-left max-width-25';
                       } else if (i === 1 || i === 2 || i === 3) {
                           result = 'no-padding-left max-width-25';
                       } else {
                           result = 'no-padding-left max-width-12';
                       }
                    }
                      break;
            case 10 : {
                       if (i === 0) {
                           result = 'no-padding-left max-width-25';
                       } else if (i === 1 || i === 2 || i === 3) {
                           result = 'no-padding-left max-width-25';
                       } else {
                           result = 'no-padding-left max-width-12';
                       }
                    }
                      break;
            case 9 : {
                       if (i === 0) {
                           result = 'no-padding-left max-width-25';
                       } else if (i === 1 || i === 2 || i === 3) {
                           result = 'no-padding-left max-width-25';
                       } else {
                           result = 'no-padding-left max-width-12';
                       }
                    }
                     break;
            case 8 : {
                       if (i === 0) {
                           result = 'no-padding-left max-width-24';
                       } else if (i === 1 || i === 2) {
                           result = 'no-padding-left max-width-32';
                       } else {
                           result = 'no-padding-left max-width-12';
                       }
                    }
                     break;
            case 7: {
                        if (chunk.length === 1) {
                            result = 'no-padding-left medium-2';
                        } else if (chunk.length === 2) {
                            result = 'no-padding-left medium-3';
                        } else if (chunk.length === 3) {
                            result = 'no-padding-left medium-4';
                        }
                    }
                    break;
            case 6: {
                        if (chunk.length === 1) {
                            result = 'no-padding-left medium-2';
                        } else if (chunk.length === 2) {
                            result = 'no-padding-left medium-3';
                        } else if (chunk.length === 3) {
                            result = 'no-padding-left medium-5';
                        }
                    }
                    break;
            case 5: result = 'five-status-chunk';
                    break;
            case 4: result = 'four-status-chunk';
                    break;
            case 3: result = 'three-status-chunk';
                    break;
            case 2:
            case 1:
            case 0: {
                        if (chunk.length === 1) {
                            result = 'no-padding-left medium-2';
                        } else if (chunk.length === 2) {
                            result = 'no-padding-left medium-3';
                        } else if (chunk.length === 3) {
                            result = 'no-padding-left medium-4';
                        }
                    }
                    break;
        }
        return result;
    }
}
